<template>
    <div class="shimmer ftb_details_header_mobile">
        <!-- Shimmer Effect for Content (Header) -->
        <div class="shimmer-score"></div>
        <div class="shimmer-tab">
            <div class="shimmer-tabs"></div>
            <div class="shimmer-tabs"></div>
            <div class="shimmer-tabs"></div>
            <div class="shimmer-tabs"></div>
        </div>
        <div class="shimmer-slider"></div>
        <div class="shimmer-score shimmer-overview"></div>
    </div>
</template>
<script>
    export default {
        name: 'matchdetail-shimmer',
    }
</script>
<style scope>
    .shimmer-loader{display:block;position:relative;background:#f4f4f4;width:100%;height:100%;border-radius:16px}.shimmer-header,.shimmer-score,.shimmer-tabs,.shimmer-timer{background:#e0e0e0;margin-bottom:20px;border-radius:4px;height:320px;animation:1.5s linear infinite shimmer;background:linear-gradient(90deg,#f4f4f4 25%,#e0e0e0 50%,#f4f4f4 75%);background-size:200% 100%}.shimmer-score{width:100%;border-radius: 20px;}.shimmer-tabs{width:20%; height: 50px;}.shimmer-tab{display: flex;gap: 5px;}.shimmer-slider{display: none;}
    /* media query for mobile */
    @media screen and (max-width: 768px) {
        .shimmer.ftb_details_header_mobile{background: #193166;}
        .shimmer-score{border-radius: 0px;background: #193166; height: 366px; }
        .shimmer-overview{background: white !important;}
        .shimmer-slider{display: block; width: 100%; height: 50px; background: #0C2251;}
        .shimmer-tab{display: none;}
        @keyframes shimmer {
            0% {
                background-position: -200% 0;
            }
            100% {
                background-position: 200% 0;
            }
        }

        .shimmer-score {
            border-radius: 0px;
            height: 366px;
            background: linear-gradient(
                90deg,
                #193166 25%,
                #1e3b80 50%,
                #193166 75%
            );
            background-size: 200% 100%;
            animation: shimmer 1.5s linear infinite;
        }
    }
</style>